import { render, staticRenderFns } from "./prestoreAccount2.vue?vue&type=template&id=07241425&scoped=true"
import script from "./prestoreAccount2.vue?vue&type=script&lang=js"
export * from "./prestoreAccount2.vue?vue&type=script&lang=js"
import style0 from "./prestoreAccount2.vue?vue&type=style&index=0&id=07241425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07241425",
  null
  
)

export default component.exports